import {ResourceEnumerate} from '@aofl/resource-enumerate';
import resourceEnumerateConfig from './__config/resource-enumerate-config';
import {environmentTypeEnumerate} from '@aofl/server-environment';
import {apiNamespaces, sdoNs} from '@modules/constants-enumerate';
import {storeInstance} from '@aofl/store/dist/legacy';

const resourceEnumerateInstance = new ResourceEnumerate(environmentTypeEnumerate.PROD);
resourceEnumerateInstance.init(resourceEnumerateConfig);

resourceEnumerateInstance.after((request, response, next) => {
  if (response.success === 'FALSE') {
    throw response.payload;
  }

  if (request.namespace === apiNamespaces.EMS && typeof response.payload.action !== 'undefined') {
    storeInstance.commit({
      namespace: sdoNs.LOCALE_DD,
      mutationId: 'setGeoipCountry',
      payload: response.payload.action.geoip_country,
    },
    {
      namespace: sdoNs.LOCALE_DD,
      mutationId: 'setIpInfo',
      payload: response.payload.action.ip_info,
    });
  }

  return next(response);
});

export {
  resourceEnumerateInstance
};
